import {
  Modal,
  useTranslation,
  ButtonAlignment,
  ButtonStyles,
  ButtonSize,
  Theme,
  Button,
  TextAlign,
} from '@nextgen-web-framework/all';
import type { AppState } from '@nextgen-web-framework/core';
import { useSelector } from 'react-redux';
import { InitialCartState, OrderType, SubCartDetail } from '@commerce-cart-webcomponents/sdk';
import { PromoModalProps } from './types/propsType';
import styles from './PromoModal.module.scss';

export const PromoModal = ({ onPrimaryClick, onSecondaryClick, onReviewCartClick }: PromoModalProps) => {
  const t = useTranslation();
  const commerceCartState = useSelector((state: AppState) => state.commerceCart);
  const { cart }: InitialCartState = commerceCartState;
  const headLineText = t('cart.promoModal.headLine');
  const primaryButtonText = t('cart.promoModal.primaryLabel');
  const reviewCartText = t('cart.promoModal.reviewCarts');
  const secondaryButtonText = t('cart.promoModal.secondaryLabel');
  const headingText = t('cart.promoModal.heading');

  const hideContinueToCheckoutBtn = cart.subCarts.some(
    (subCart: SubCartDetail) => subCart?.disableSpecialOfferCheckout ?? false,
  );

  return (
    <Modal
      buttonAlignment={ButtonAlignment.VERTICAL}
      primaryButtonLabel={''}
      headline={headLineText}
      closeIcon={false}
      data-testid="modal-component"
      textAlign={TextAlign.CENTER}
      useReactPortal={true}
      portalContainerId="react-portal-modal"
    >
      <>
        <span>{headingText}</span>
        <div className={styles['merge-promotion-button-container']}>
          <Button
            title={cart.orderType === OrderType.Gco ? reviewCartText : primaryButtonText}
            buttonStyle={ButtonStyles.SOLID}
            theme={Theme.BLACK}
            size={ButtonSize.MEDIUM}
            role="button"
            data-testid="show-offers-button"
            onClick={cart.orderType === OrderType.Gco ? onReviewCartClick : onPrimaryClick}
            aria-label={primaryButtonText}
          />

          {!hideContinueToCheckoutBtn && (
            <Button
              title={secondaryButtonText}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.BLACK}
              size={ButtonSize.MEDIUM}
              role="button"
              data-testid="continue-to-checkout-btn"
              onClick={onSecondaryClick}
              aria-label={secondaryButtonText}
            />
          )}
        </div>
      </>
    </Modal>
  );
};
